import { TableSettingsStateItem } from '@store/table-settings/interfaces/table-settings-state.model';

export const TableSettingsDefault: TableSettingsStateItem = {
    requestSettings: {
        pageNumber: 1,
        pageSize: 25,
        orderBy: '',
        reverse: false,
        filters: [],
    },
    filterOpen: false,
    columnSettings: [],
};
